namespace GeniuzPOS.Purchase {
    export enum paymenttypefg {
        cash = 1,
        credit = 2,
        debit = 3,
        check = 7,
        qr = 8,
        other = 10
    }
    Serenity.Decorators.registerEnumType(paymenttypefg, 'GeniuzPOS.Purchase.paymenttypefg');
}
